import { functions } from '../api/firebase/firebase';

export type StudentInformationIssueType = 'load-error' | 'repair-error';

export type StudentInformationRecoveryStatus = 'unavailable' | 'idle' | 'in_progress' | 'succeeded' | 'failed';

export type StudentInformationRecoveryResult = {
  status: StudentInformationRecoveryStatus;
  attemptId?: string;
  canRetry: boolean;
};

export type StudentInformationRecoveryAction = 'start' | 'retry' | 'status';

export type StudentInformationSupportRequest = {
  organizationId: string;
  studentId: string;
  requestId: string;
  issueType: StudentInformationIssueType;
};

export async function recoverStudentInformation(request: {
  organizationId: string;
  studentId: string;
  action: StudentInformationRecoveryAction;
  attemptId?: string;
}): Promise<StudentInformationRecoveryResult> {
  const result = await functions().httpsCallable('callables-support-recoverStudentInformation')(request);
  return result.data;
}

export async function sendStudentInformationSupportRequest(
  request: StudentInformationSupportRequest
): Promise<{ requestId: string }> {
  const result = await functions().httpsCallable('callables-support-sendStudentInformationRequest')(request);
  return result.data;
}
